<div class="header-modal mb-0">
  <div class="main-title w-100 mt-0 mb-0">
    <h3>Set Specialist End Date</h3>
  </div>

  <span *ngIf="!loading" class="close-dialog" mat-dialog-close>
      <i class="material-icons">close</i>
    </span>
</div>
<div *ngIf="loading">
  <div class="loader"></div>
  <p class="txt-loader mb-30">Please wait until the Specialist End Date is updated ...</p>
</div>
<div *ngIf="!loading">
  <mat-card class="row d-flex justify-content-center inline-calendar-card">
    <mat-calendar #calendar
                  class="col-md-12"
                  [startAt]="selected"
                  [(selected)]="selected"
                  [minDate]="specialistData ? specialistData?.startDate : null"
    ></mat-calendar>
  </mat-card>
</div>
<div *ngIf="!loading" class="float-right mt-30">
  <cmp-button text="Set" (onClick)="onChangeSurveyDate()"></cmp-button>
</div>
